function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#333"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 190,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 190,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 193,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 194,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 197,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 196,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 195,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 195,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 194,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 194,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 193,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 187,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 192,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 191,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 188,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 186,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 190,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 185,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 182,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 181,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 180,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 179,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 115,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 114,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 178,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 172,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 171,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 170,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 169,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 122,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 119,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 118,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 117,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 116,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 113,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 109,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 173,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 167,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 164,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 162,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 161,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 154,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 153,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 106,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 105,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 103,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 102,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 160,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 159,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 158,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 151,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 150,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 146,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 127,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 126,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 124,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 123,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 149,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 148,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 143,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 142,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 130,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 129,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 133,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 132,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 131,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 91,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 157,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 156,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 141,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 155,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 163,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 139,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 166,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 175,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 174,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 177,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 86,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 89,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 87,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 112,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 107,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 99,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 92,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 98,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 101,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 94,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 93,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 100,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 97,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 96,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 96,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 96,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 96,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 95,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 95,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 94,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 94,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 94,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 93,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 93,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 93,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 92,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 92,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 92,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 92,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 92,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 91,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 91,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 91,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 91,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 91,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 90,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 89,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 88,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 87,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 86,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 85,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 84,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 83,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 82,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 80,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 79,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 78,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 77,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 76,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 74,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 72,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 71,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 70,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 69,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 68,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 67,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 66,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 65,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 64,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 63,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 62,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 61,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 60,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 59,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 58,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 57,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 56,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 55,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 54,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 53,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 52,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 51,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 49,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 48,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 47,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 46,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 45,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 44,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 43,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 41,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 40,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 39,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 37,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 34,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 31,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 30,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 24,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 23,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 22,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 21,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 20,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 19,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.9,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.9,
  cy: 17,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.9,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.9,
  cy: 16,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.9,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.9,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.9,
  cy: 15,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.9,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.9,
  cy: 14,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5.9,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4.9,
  cy: 13,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 12,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 11,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 10,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 31,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 29,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 9,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 8,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 50,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 39,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 34,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 7,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 6,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 5,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 4,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 52,
  cy: 3,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 84,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 83,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 82,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 78,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 74,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 73,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 72,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 71,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 70,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 69,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 66,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 64,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 63,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 62,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 61,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 59,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 57,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 54,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 2,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81,
  cy: 1,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 1,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65,
  cy: 1,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 81,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 75,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 73,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 46,
  cy: 50,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 42,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 38,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 38,
  cy: 36,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 35,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 27,
  cy: 33,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 32,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 29,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 28,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23,
  cy: 27,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 47,
  cy: 26,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 25,
  r: 0.3
}), /*#__PURE__*/React.createElement("circle", {
  cx: 95,
  cy: 21,
  r: 0.3
}));

function SvgWorldMapWithPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 660,
    height: 320,
    viewBox: "0 0 201 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldMapWithPoints);
export default __webpack_public_path__ + "static/media/World_map_with_points.17e0eb1e.svg";
export { ForwardRef as ReactComponent };